/**
  Note: Please update versiversionnon per servter - to indicate new deployment updserverURL: 'https://glp-test-f6590.appspot.com',tes
  APP_TYPE_SERVER ==> public_test OR corporate_test OR public_live OR corporate_live
**/

const APP_TYPE_SERVER = 'public_live'
// Number of reports required before a comment gets hidden/flagged
const COMMENT_REPORT_LIMIT = 5

const config = {
  // public_test: {
  //   APP_TYPE: 'PUBLIC',
  //   SERVER_TYPE: 'TEST',
  //   FB_URL: 'https://us-central1-thinklead-b3299.cloudfunctions.net/',
  //   BASE_API_URL: 'https://us-central1-thinklead-b3299.cloudfunctions.net/api',
  //   BASE_URL: 'https://us-central1-thinklead-b3299.cloudfunctions.net',
  //   DB_CONFIG: 'public_test',
  //   graphQLURL: 'https://us-central1-leadershipplatform-158316.cloudfunctions.net/api/graphql',
  //   serverURL: 'https://thinklead-b3299.uc.r.appspot.com/',
  //   version: '2.2',
  //   IS_HARMONY: false
  // },
  public_test: {
    APP_TYPE: 'PUBLIC',
    SERVER_TYPE: 'TEST',
    FB_URL: 'https://us-central1-thinklead-b3299.cloudfunctions.net/',
    BASE_API_URL: 'https://us-central1-thinklead-b3299.cloudfunctions.net/api',
    BASE_URL: 'https://us-central1-thinklead-b3299.cloudfunctions.net',
    DB_CONFIG: 'public_test',
    graphQLURL: 'https://us-central1-leadershipplatform-158316.cloudfunctions.net/api/graphql',
    serverURL: 'https://thinklead-b3299.uc.r.appspot.com/',
    version: '2.2',
    IS_HARMONY: false
  },
  corporate_test: {
    APP_TYPE: 'CORPORATE',
    SERVER_TYPE: 'TEST',
    FB_URL: 'https://us-central1-glp-test-f6590.cloudfunctions.net',
    BASE_API_URL: 'https://us-central1-glp-test-f6590.cloudfunctions.net/api',
    BASE_URL: 'https://us-central1-glp-test-f6590.cloudfunctions.net',
    DB_CONFIG: 'test',
    serverURL: 'https://glp-test-f6590.appspot.com',
    version: '1.0',
    IS_HARMONY: true
  },
  public_live: {
    APP_TYPE: 'PUBLIC',
    SERVER_TYPE: 'LIVE',
    FB_URL: 'https://us-central1-leadershipplatform-158316.cloudfunctions.net/',
    BASE_API_URL:
      'https://us-central1-leadershipplatform-158316.cloudfunctions.net/api',
    BASE_URL:
      'https://us-central1-leadershipplatform-158316.cloudfunctions.net',
    DB_CONFIG: 'live',
    serverURL: 'https://leadershipplatform-158316.appspot.com',
    version: '2.0',
    IS_HARMONY: false
  },
  corporate_live: {
    APP_TYPE: 'CORPORATE',
    SERVER_TYPE: 'LIVE',
    FB_URL: 'https://us-central1-harmony-thinklead.cloudfunctions.net/',
    BASE_URL:
      'https://us-central1-harmony-thinklead.cloudfunctions.net',
    BASE_API_URL:
      'https://us-central1-harmony-thinklead.cloudfunctions.net/api',
    DB_CONFIG: 'live',
    serverURL: 'https://glp-corporate.appspot.com/',
    version: '2.2',
    IS_HARMONY: true
  }
}

export const app_config = config[APP_TYPE_SERVER]

export { COMMENT_REPORT_LIMIT }

// Number of characters to store for transcript duplicate detection
// Can be set to 50 or 100 (or overriden per call). Default 100
export const TRANSCRIPT_EXCERPT_LENGTH = 100
// Window (in characters) for compact transcript signatures (first/last slices)
// We apply space-compaction and then take every Nth character to build a small signature
export const TRANSCRIPT_SIGNATURE_WINDOW = 200

// Tuning knobs for transcript near-duplicate detection
// Adjust cautiously; increasing threshold makes matching stricter
export const TRANSCRIPT_DUP_NGRAM_N = 2
export const TRANSCRIPT_DUP_SIMILARITY_THRESHOLD = 0.92
export const TRANSCRIPT_DUP_LENGTH_TOLERANCE = 0.15
export const TRANSCRIPT_DUP_MAX_CANDIDATES = 500
// Character-level strictness for edge windows (first/last). If either window
// is ≥ this similarity with a stored excerpt, treat as duplicate regardless of n-gram score.
export const TRANSCRIPT_DUP_CHAR_SIM_THRESHOLD = 0.99